var map = {
	"./child-power-small.svg": [
		6196,
		6196
	],
	"./child-power.svg": [
		1676,
		1676
	],
	"./childhood-strides-small.svg": [
		4252,
		4252
	],
	"./childhood-strides.svg": [
		3719,
		8534
	],
	"./climate-action-small.svg": [
		2393,
		2393
	],
	"./climate-action.svg": [
		434,
		434
	],
	"./equality-for-some-small.svg": [
		5624,
		5624
	],
	"./equality-for-some.svg": [
		4099,
		4099
	],
	"./eyes-on-equality-small.svg": [
		9927,
		9927
	],
	"./eyes-on-equality.svg": [
		8559,
		8559
	],
	"./free-to-be-young-small.svg": [
		8643,
		8643
	],
	"./free-to-be-young.svg": [
		3904,
		3904
	],
	"./future-fortunes-small.svg": [
		4292,
		4292
	],
	"./future-fortunes.svg": [
		9681,
		9681
	],
	"./global-citizens-2021.svg": [
		71,
		71
	],
	"./global-citizens-small-2021.svg": [
		4684,
		4684
	],
	"./global-citizens-small.svg": [
		2317,
		2317
	],
	"./global-citizens.svg": [
		2439,
		2439
	],
	"./global-outlook-small.svg": [
		2558,
		2558
	],
	"./global-outlook.svg": [
		7183,
		7183
	],
	"./go-to-sources-2021-small.svg": [
		7657,
		7657
	],
	"./go-to-sources-2021.svg": [
		4445,
		4445
	],
	"./go-to-sources-small.svg": [
		5105,
		5105
	],
	"./go-to-sources.svg": [
		9810,
		9810
	],
	"./is-scrolling-believing-2021-small.svg": [
		4434,
		4434
	],
	"./is-scrolling-believing-2021.svg": [
		6420,
		6420
	],
	"./is-scrolling-believing-small.svg": [
		8822,
		8822
	],
	"./is-scrolling-believing.svg": [
		6361,
		6361
	],
	"./mental-burdens-small.svg": [
		3160,
		3160
	],
	"./mental-burdens.svg": [
		8320,
		8320
	],
	"./online-opportunities-small.svg": [
		5438,
		5438
	],
	"./online-opportunities.svg": [
		4866,
		4866
	],
	"./online-risks-small.svg": [
		2551,
		2551
	],
	"./online-risks.svg": [
		6503,
		6503
	],
	"./the-other-climate-crisis-2021-small.svg": [
		7332,
		7332
	],
	"./the-other-climate-crisis-2021.svg": [
		8967,
		8967
	],
	"./the-other-climate-crisis-small.svg": [
		5496,
		5496
	],
	"./the-other-climate-crisis.svg": [
		6575,
		7861
	],
	"./under-pressure-small.svg": [
		9313,
		9313
	],
	"./under-pressure.svg": [
		2365,
		2365
	],
	"./where-you-call-home-2021-small.svg": [
		673,
		673
	],
	"./where-you-call-home-2021.svg": [
		2340,
		2340
	],
	"./where-you-call-home-small.svg": [
		6091,
		6091
	],
	"./where-you-call-home.svg": [
		6283,
		6283
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 2592;
module.exports = webpackAsyncContext;